"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _base = _interopRequireDefault(require("@emotion/styled/base"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _NewLabel = require("./NewLabel.styles");

var Label = (0, _base["default"])("span", {
  target: "eson8fw0",
  label: "Label"
})(_NewLabel.styles.base, ";");

var NewLabel = function NewLabel(_ref) {
  var className = _ref.className,
      isInfiniteAnimation = _ref.isInfiniteAnimation,
      size = _ref.size;
  return (0, _jsxRuntime.jsxs)(Label, {
    className: className,
    isInfiniteAnimation: isInfiniteAnimation,
    size: size,
    children: [(0, _jsxRuntime.jsx)("span", {
      children: "N"
    }), (0, _jsxRuntime.jsx)("span", {
      children: "E"
    }), (0, _jsxRuntime.jsx)("span", {
      children: "W"
    })]
  });
};

NewLabel.propTypes = {
  className: _propTypes.string,

  /**
   * Infinite animation with around 5s delay for each one
   */
  isInfiniteAnimation: _propTypes.bool,
  size: (0, _propTypes.oneOf)(['big', 'small'])
};
NewLabel.defaultProps = {
  className: undefined,
  isInfiniteAnimation: false,
  size: 'big'
};
var _default = NewLabel;
exports["default"] = _default;
//# sourceMappingURL=NewLabel.js.map